var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "dropdown-menu" }, [
    _c("li", [
      _c("ul", { staticClass: "fancy_checkbox_list" }, [
        _c("li", [
          _c(
            "button",
            {
              class: [
                "btn btn-sm",
                { "btn-primary active": _vm.status[_vm.fieldName]["hide"] },
                { "btn-default": !_vm.status[_vm.fieldName]["hide"] },
              ],
              on: {
                click: function ($event) {
                  return _vm.click("hide")
                },
              },
            },
            [_vm._v("Hide links between " + _vm._s(_vm.fieldName))]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "pt2" }, [
          _c(
            "button",
            {
              class: [
                "btn btn-sm",
                { "btn-primary active": !_vm.status[_vm.fieldName]["hide"] },
                { "btn-default": _vm.status[_vm.fieldName]["hide"] },
              ],
              on: {
                click: function ($event) {
                  return _vm.click("hide")
                },
              },
            },
            [_vm._v("Show links between " + _vm._s(_vm.fieldName))]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.fieldName == "datasets"
      ? _c("li", [
          _c("div", { staticClass: "divider", attrs: { role: "separator" } }),
          _vm._v(" "),
          _c("ul", { staticClass: "fancy_checkbox_list" }, [
            _c("li", [
              _c(
                "button",
                {
                  class: [
                    "btn btn-sm",
                    {
                      "btn-primary active":
                        _vm.status[_vm.fieldName]["collapseDataset"],
                    },
                    {
                      "btn-default":
                        !_vm.status[_vm.fieldName]["collapseDataset"],
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.click("collapseDataset")
                    },
                  },
                },
                [_vm._v("Collapse datasets")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pt2" }, [
              _c(
                "button",
                {
                  class: [
                    "btn btn-sm",
                    {
                      "btn-primary active":
                        !_vm.status[_vm.fieldName]["collapseDataset"],
                    },
                    {
                      "btn-default":
                        _vm.status[_vm.fieldName]["collapseDataset"],
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.click("collapseDataset")
                    },
                  },
                },
                [_vm._v("Expand datasets")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fieldName == "distributions"
      ? _c("li", [
          _c("div", { staticClass: "divider", attrs: { role: "separator" } }),
          _vm._v(" "),
          _c("ul", { staticClass: "fancy_checkbox_list" }, [
            _c("li", [
              _c(
                "button",
                {
                  class: [
                    "btn btn-sm",
                    {
                      "btn-primary active":
                        _vm.status[_vm.fieldName]["collapseDistribution"],
                    },
                    {
                      "btn-default":
                        !_vm.status[_vm.fieldName]["collapseDistribution"],
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.click("collapseDistribution")
                    },
                  },
                },
                [_vm._v("Collapse distributions")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "pt2" }, [
              _c(
                "button",
                {
                  class: [
                    "btn btn-sm",
                    {
                      "btn-primary active":
                        !_vm.status[_vm.fieldName]["collapseDistribution"],
                    },
                    {
                      "btn-default":
                        _vm.status[_vm.fieldName]["collapseDistribution"],
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.click("collapseDistribution")
                    },
                  },
                },
                [_vm._v("Expand distributions")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("li", { staticClass: "divider", attrs: { role: "separator" } }),
    _vm._v(" "),
    _c("li", [
      _c("ul", { staticClass: "fancy_checkbox_list" }, [
        _c(
          "li",
          {
            on: {
              click: function ($event) {
                return _vm.click("dashed")
              },
            },
          },
          [
            _c("input", {
              ref: "dashed-ref",
              attrs: { type: "radio" },
              domProps: { checked: _vm.status[_vm.fieldName]["dashed"] },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            on: {
              click: function ($event) {
                return _vm.click("dotted")
              },
            },
          },
          [
            _c("input", {
              ref: "dotted-ref",
              attrs: { type: "radio" },
              domProps: { checked: _vm.status[_vm.fieldName]["dotted"] },
            }),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", [
        _c("i", { staticClass: "fas fa-horizontal-rule" }),
        _vm._v(" Dashed"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", [
        _c("i", { staticClass: "fas fa-horizontal-rule" }),
        _vm._v(" "),
        _c("i", { staticClass: "fas fa-horizontal-rule" }),
        _vm._v(" Dotted"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }